import { useStore } from '../../store/store';

export class NumbersUtil {
  static numberWithSpaces(x: number, fixedNumbers = 0) {
    const parts = x.toFixed(fixedNumbers).toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join('.');
  }

  static formatNumberWithLetters(number: number | null) {
    if (number === null) return '-';
    const catalog = useStore.getState().catalog;
    if (!catalog) return number.toString();
    return Intl.NumberFormat(catalog.language, { notation: 'compact' }).format(number);
  }

  /**
    Takes in a month as a number and an optional separator and returns a formatted date string in the format of MM/YYYY.
    If no separator is provided, a forward slash (/) is used by default.
    @param month The month as a number (e.g. 202301)
    @param separator The optional separator to be used in the formatted date string (default is '/')
    @returns A formatted date string in the format of MM/YY (e.g. 01/23)
    */
  static formatMonthsDateToString(month: number, separator = '/') {
    return `${month.toString().charAt(4)}${month.toString().charAt(5)}${separator}${month.toString().charAt(2)}${month.toString().charAt(3)}`;
  }

  static formatNumberToPrice(value?: number | null) {
    if (value === undefined || value === null || Number.isNaN(value)) return '-';

    const { currency, language } = useStore.getState().catalog!;
    // @ts-ignore to ignore the error due to the use of experimental features like trailingZeroDisplay
    return Intl.NumberFormat(language, {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
      trailingZeroDisplay: 'stripIfInteger',
    }).format(value);
  }

  static formatNumberToPriceWithoutSymbol(value: number) {
    const { language } = useStore.getState().catalog!;
    return value.toLocaleString(language, { maximumFractionDigits: 2 });
  }
}
